import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  margin-bottom: 1rem;

  .label-name {
    font-size: 1.4rem;
    color: black;
    margin-right: 2rem;
    margin-top: 1rem;

    &.error {
      color: ${(props) => props.theme.palette.error};
    }
  }

  .label-error {
    color: ${(props) => props.theme.palette.error};
    font-size: 1.1rem;
    width: 100%;
  }
`

const Label = function ({ name, error }) {
  return (
    <Container>
      {name && (
        <span className={`label-name ${error ? 'error' : ''}`}>{name}</span>
      )}
      <span className="label-error">{error}</span>
    </Container>
  )
}

export default Label
